import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPennantPill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 4.25C5 3.42157 5.67157 2.75 6.5 2.75H17.5C18.3284 2.75 19 3.42157 19 4.25V20.4591C19 21.4272 17.9126 21.9968 17.1167 21.4456L12.8541 18.4931C12.3403 18.1372 11.6597 18.1372 11.1459 18.4931L6.88327 21.4456C6.08742 21.9968 5 21.4272 5 20.4591V4.25Z",
		fill: "currentColor"
	})
});
export { SvgIconPennantPill as ReactComponent };
